/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import BaseModal from 'src/common/components/Modal';
import { COLUMN_RESOLUTIONS_DETAIL, COLUMNS_TEMAS_PREVIEW } from '../utils/list_data';
import BootstrapTable from 'react-bootstrap-table-next';
import notice from 'src/common/components/Notice';
import DeleteResolutions from './DeleteResolutions';
import { topicAPI } from 'src/api/modules/topic';
import { inclusionThemesAPI } from 'src/api/modules/inclusionThemes';
import { download } from 'src/pages/Files/UpaloadFileMinos';

const DetailOrder = ({ order, isOpen, onClose, user, canEdit, nameSesion }) => {
	const [resolutions, setResolutions] = useState([]);
	const [issues, setIssues] = useState([]);
	const [resolutionSelected, setResolutionSelected] = useState([]);
	const [issueSelected, setIssueSelected] = useState([]);
	const [deleteModal, setDeleteModal] = useState(false);

	React.useEffect(() => {
		getResolutions();
	}, [order]);
	const onDownload = (ruta) => {
		if (ruta.ruta !== undefined) {
			download(
				ruta.ruta,
				ruta.nombre,
				user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
				false,
				'Vista Previa en orden del día, de la sesión ' + nameSesion
			);
		}
	};
	const selectRowResolutions = {
		mode: 'checkbox',
		clickToSelect: false,
		onSelect: (row, isSelect) => {
			if (row && row.id) {
				if (!isSelect) {
					const newSelected = resolutionSelected.filter((id) => id !== row.id);
					setResolutionSelected(newSelected);
				} else {
					setResolutionSelected([
						...resolutionSelected,
						{ id: row.id, tipoTema: 1 },
					]);
				}
			}
		},
	};
	const selectRowIssues = {
		mode: 'checkbox',
		clickToSelect: false,
		onSelect: (row, isSelect) => {
			if (row && row.id) {
				if (!isSelect) {
					const newSelected = issueSelected.filter((id) => id !== row.id);
					setIssueSelected(newSelected);
				} else {
					setIssueSelected([...issueSelected, { id: row.id, tipoTema: 0 }]);
				}
			}
		},
	};
	const onCloseModalDelete = () => {
		setDeleteModal(false);
	};
	const onSuccess = (msg, type_msg) => {
		notice(msg, type_msg);
		getResolutions();
		setDeleteModal(false);
		onClose();
	};

	const getResolutions = () => {
		topicAPI
			.getResolutionsPoint(order.id)
			.then((response) => {
				if (response?.temas?.length > 0) {
					const oficio = response.temas[0]?.archivos.find(
						(x) => x.tipo === 'O'
					);
					const tarjeta = response.temas[0]?.archivos.find(
						(x) => x.tipo === 'T'
					);
					const presentacion = response.temas[0]?.archivos.find(
						(x) => x.tipo === 'P'
					);
					const adicional = response.temas[0]?.archivos.find(
						(x) => x.tipo === 'A'
					);
					const x = response.temas[0];
					const obj = [
						{
							...x,
							oficio: oficio,
							tarjeta: tarjeta,
							presentacion: presentacion,
							adicional: adicional,
						},
					];
					setResolutions(obj);
				}
			})
			.catch((e) => {
				if (e) notice('Ha ocurrido un problema con la solicitud', 'error');
			});

		inclusionThemesAPI
			.getIssuesByOrder(order.id)
			.then((response) => {
				if (response.length > 0) {
					const oficio = response[0]?.archivos.find((x) => x.tipo === 'O');
					const tarjeta = response[0]?.archivos.find((x) => x.tipo === 'T');
					const presentacion = response[0]?.archivos.find(
						(x) => x.tipo === 'P'
					);
					const adicional = response[0]?.archivos.find((x) => x.tipo === 'A');
					const x = response[0];
					const newArr = [
						{
							...x,
							oficio: oficio,
							tarjeta: tarjeta,
							presentacion: presentacion,
							adicional: adicional,
						},
					];
					setIssues(newArr);
				}
			})
			.catch((e) => {
				if (e) notice('Ha ocurrido un problema con la solicitud', 'error');
			});
	};
	return (
		<BaseModal
			open={isOpen}
			onClose={() => {
				onClose();
			}}
			onCancel={() => {
				onClose();
			}}
			onConfirm={
				canEdit === false
					? undefined
					: () => {
							setDeleteModal(true);
					  }
			}
			confirmLabel={'Eliminar Seleccionados'}
			cancelLabel={canEdit === false ? 'Cerrar' : 'Cancelar'}
			maxWidth="lg"
			mainText="Vista Previa"
		>
			<div className="mb-8" style={{ fontSize: 15 }}>
				<b>Nombre del Punto: </b>
				{order.name}
			</div>
			<h5>
				<b>Resoluciones / Recomendaciones</b>
			</h5>
			<BootstrapTable
				caption=""
				keyField="id"
				data={resolutions}
				columns={COLUMN_RESOLUTIONS_DETAIL(onDownload)}
				selectRow={selectRowResolutions}
			/>
			<br></br>
			<br></br>
			<h5>
				<b>Temas</b>
			</h5>
			<BootstrapTable
				caption=""
				keyField="id"
				data={issues}
				columns={COLUMNS_TEMAS_PREVIEW(onDownload)}
				selectRow={selectRowIssues}
			/>
			<DeleteResolutions
				open={deleteModal}
				resolutions={resolutionSelected}
				themes={issueSelected}
				onClose={onCloseModalDelete}
				onSuccess={onSuccess}
			/>
		</BaseModal>
	);
};

export default DetailOrder;
